import { Grid } from '@mui/material';
import { Field } from 'formik';
import React from 'react';
import HdFormikPasswordField from '../../../../../form/formik/components/password-field/HdFormikPasswordField';
import HdFormikTextField from '../../../../../form/formik/components/text-field/HdFormikTextField';
import RequestSSHAccess from '../../../../../connector/connector-form/components/connector-reusable-options/RequestSSHAccess';
import HdFormControl from '../../../../../form/components/form-control/HdFormControl';

export default function Marketo({ isEditing }: { isEditing: boolean }) {
  const sshAccessMessage =
    'If Marketo IP restriction is enabled, whitelist the following Hevo IP addresses';

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='clientID'
              label='Client ID'
              helperText='Specify your Client ID.'
              required
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='clientSecret'
              required
              label='Client Secret'
              helperText='Specify your Client Secret.'
              masked={isEditing}
              component={HdFormikPasswordField}
            />
          </HdFormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='subDomain'
              label='Sub Domain'
              helperText='Specify your Marketo URL (https://subdomain.mktorest.com)'
              required
              prefixText='https://'
              suffixText='.mktorest.com'
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <RequestSSHAccess message={sshAccessMessage} />
        </Grid>
      </Grid>
    </>
  );
}
